// 구독 관리 관련 API 유틸 함수들
import { post, get } from '../helpers/api.helper';
import config from '../config/config';

export interface SubscriptionApproveRequest {
    amount: number;
    planId: string;
    description?: string;
}

export interface SubscriptionCancelRequest {
    subscriptionId: string;
    reason?: string;
}

export interface BillKeyRemoveRequest {
    billKeyId: string;
}

export interface BillKeyStatusResponse {
    isActive: boolean;
    cardMasked: string;
    cardName: string;
    registeredAt: string;
}

export interface PaymentDetailsResponse {
    transactionId: string;
    amount: number;
    status: string;
    paidAt: string;
    failureReason?: string;
}

// Fitting 구독 상품 조회 응답 타입
export interface FittingProductFeature {
    text: string;
    isIncluded: boolean;
    isAddOn?: boolean;
}

export interface FittingProductFeatureGroup {
    title: string;
    features: FittingProductFeature[];
}

export interface FittingProductPlan {
    id: string;
    billingCycle: 'monthly' | 'yearly';
    intervalCount: number;
    autoRenew: 't' | 'f' | string;
}

export interface FittingProductItem {
    id: string;
    name: string;
    creditAmount: number;
    originalPrice: number;
    discountAmount: number;
    totalCharge: number;
    description: string;
    createdAt: string;
    updatedAt: string;
    features: FittingProductFeatureGroup[];
    fittingSubscriptionPlans: FittingProductPlan[];
}

export interface FittingProductListResponse {
    data: FittingProductItem[];
    count: number;
    total: number;
    page: number;
    pageCount: number;
}

/**
 * 구독 상품 목록 조회
 */
export async function getFittingProducts(query?: string): Promise<FittingProductListResponse> {
    const response = await get(`${config.api.matching_api}/fitting/product${query ? `?${query}` : ''}`);
    return response.data as FittingProductListResponse;
}

/**
 * 구독 결제 승인 요청
 */
export async function approveSubscriptionPayment(data: SubscriptionApproveRequest) {
    const response = await post(`${config.api.matching_api}/billing/approve`, data);
    return response.data;
}

/**
 * 구독 취소 요청
 */
export async function cancelSubscription(data: SubscriptionCancelRequest) {
    const response = await post(`${config.api.matching_api}/billing/cancel`, data);
    return response.data;
}

/**
 * 빌키(등록된 카드) 삭제
 */
export async function removeBillKey(data: BillKeyRemoveRequest) {
    const response = await post(`${config.api.matching_api}/billing/remove`, data);
    return response.data;
}

/**
 * 빌키 상태 조회
 */
export async function getBillKeyStatus(billKeyId: string): Promise<BillKeyStatusResponse> {
    const response = await get(`${config.api.matching_api}/billing/billkey/${billKeyId}/status`);
    return response.data;
}

/**
 * 결제 내역 조회
 */
export async function getPaymentDetails(transactionId: string): Promise<PaymentDetailsResponse> {
    const response = await get(`${config.api.matching_api}/billing/payments/${transactionId}`);
    return response.data;
}
